import { apiConnection } from "@/services/api-connection";

const URL_INCIDENT_SHEET = "/app/studea-manager/incident-sheet";

class IncidentSheetManager {
  INCIDENT_NONE = 0;
  INCIDENT_INPROGRESS = 1;
  INCIDENT_ENCLOSE = 2;

  getIncidentSheetListForStudeaManager(params) {
    return apiConnection.get(URL_INCIDENT_SHEET + "/list", params).then((response) => response);
  }

  delete(id) {
    return apiConnection.delete(URL_INCIDENT_SHEET + "/delete/" + id).then((response) => response);
  }

  update(id) {
    return apiConnection.put(URL_INCIDENT_SHEET + "/update/" + id).then((response) => response);
  }

  getIncidentSheetform(type, id = null) {
    return apiConnection.get(URL_INCIDENT_SHEET + "/" + type + "/form" + (id ? "/" + id : ""));
  }

  postComment(params, id) {
    return apiConnection.put(URL_INCIDENT_SHEET + "/comment/" + id, params);
  }
}

export const incidentSheetManager = new IncidentSheetManager();
